module.exports = __webpack_public_path__ + "static/media/integration.a455cf81.svg";